module.exports = __webpack_public_path__ + "img/24c9c97928e8b1fecae8890fa01da5f3.24c9c979.png";